module.exports = __webpack_public_path__ + "static/media/BannerforDashboard.55f9115c.png";